import api from './api';
export const publicService = {
    // 
    getPublicOrderDetails: async (publicToken) => {
        return api.get(`/orders/public/${publicToken}`);
    },
};